import React from 'react';

import * as s from './RubricButton.css';

interface IRubricLink {
  children: React.ReactText;
  onClick(e: React.MouseEvent): void;
}

/**
 * Кнопка рубрики
 */
export const RubricButton = ({ children, onClick }: IRubricLink) => {
  return (
    <div className={`${s['wrapper']}`} onClick={onClick}>
      {children}
    </div>
  );
};
